import React from 'react'


export default function Eimpacts() {
  return (
    <section className='mt-5 mb-5'>
        <div className='container'>
            <div className='row'>
                <div className='col-12'>

                    <div className='mb-3 '>
                        <h4 className='font-italic d-inline p-1 bg-warning'>Environmental impacts</h4><br></br>
                    </div>
                    
                    <div>
                      <p>Within natural ecosystems, invasive plants and pathogens alter the vegetative structure and reduce floristic diversity.This change often favours exotic fauna at the expense ofindigenous species which can also contribute to an increase in fuel loads.Invasive animals are a significant threat to biodiversity through competition, predation, habitat destruction and through the spread of diseases. Small native mammals, ground-nesting birds and some small reptiles are particularly susceptible to predation by mongoose and rats. 
</p>
                    </div>
                    
                </div>
            </div>
        </div>
    </section>
  )
}

